import React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Link } from 'react-router-dom';
import { SimplePageTitle } from '@/components/layout/PageTitle';
import ProjectCatalogProducts from './ProjectCatalogProducts';
import { Tabs } from '@ygtechnologies/rubus-ui';

const tabs = [
    {
        id: 'products',
        name: <Trans>All products</Trans>,
        render: () => <ProjectCatalogProducts />,
    },
];

interface ProjectCatalogProps {
    tab: 'products';
}

const ProjectCatalog: React.FC<ProjectCatalogProps> = ({ tab }) => {
    const activeTab = tabs.find((t) => t.id === tab) ?? tabs[0];

    return (
        <div>
            <SimplePageTitle title={t`Project Products`} />

            <Tabs.Container activeId={tab} variant="underline" sticky>
                {tabs.map((t) => (
                    <Tabs.Tab key={t.id} id={t.id} as={Link} to={`/catalog/${t.id}`} label={t.name} />
                ))}
                <Tabs.Content>{activeTab.render()}</Tabs.Content>
            </Tabs.Container>
        </div>
    );
};

export default ProjectCatalog;
